  // import PropTypes from "prop-types";
  // import { Input } from "@/components/ui/input";
  // import { Label } from "@/components/ui/label";
  // import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

  // const LeadGenerationForm = ({ form, handleChange, formErrors, isSaving }) => (
  //   <Card className="p-4 max-w-2xl mx-auto">
  //     <CardHeader>
  //       <CardTitle>Lead Generation</CardTitle>
  //     </CardHeader>

  //     <CardContent>
  //       <form className="space-y-4">
  //         {/* Names */}
  //         <div>
  //           <Label htmlFor="firstName">First Name*</Label>
  //           <Input
  //             id="firstName"
  //             name="firstName"
  //             value={form.firstName || ""}
  //             onChange={handleChange}
  //             disabled={isSaving}
  //             required
  //             placeholder="Enter first name"
  //           />
  //           {formErrors.firstName && (
  //             <p className="text-red-500 text-sm mt-1">{formErrors.firstName}</p>
  //           )}
  //         </div>

  //         <div>
  //           <Label htmlFor="middleName">Middle Name</Label>
  //           <Input
  //             id="middleName"
  //             name="middleName"
  //             value={form.middleName || ""}
  //             onChange={handleChange}
  //             disabled={isSaving}
  //             placeholder="Enter middle name"
  //           />
  //         </div>

  //         <div>
  //           <Label htmlFor="lastName">Last Name*</Label>
  //           <Input
  //             id="lastName"
  //             name="lastName"
  //             value={form.lastName || ""}
  //             onChange={handleChange}
  //             disabled={isSaving}
  //             required
  //             placeholder="Enter last name"
  //           />
  //           {formErrors.lastName && (
  //             <p className="text-red-500 text-sm mt-1">{formErrors.lastName}</p>
  //           )}
  //         </div>

  //         {/* DOB */}
  //         <div>
  //           <Label htmlFor="dob">Date of Birth</Label>
  //           <Input
  //             id="dob"
  //             name="dob"
  //             type="date"
  //             value={form.dob}
  //             onChange={handleChange}
  //             disabled={isSaving}
  //             required
  //           />
  //           {formErrors.dob && (
  //             <p className="text-red-500 text-sm mt-1">{formErrors.dob}</p>
  //           )}
  //         </div>

  //         {/* Gender */}
  //         <div>
  //           <Label htmlFor="gender">Gender*</Label>
  //           <select
  //             id="gender"
  //             name="gender"
  //             value={form.gender || ""}
  //             onChange={handleChange}
  //             className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-blue-500"
  //             disabled={isSaving}
  //             required
  //           >
  //             <option value="">Select Gender</option>
  //             <option value="male">Male</option>
  //             <option value="female">Female</option>
  //           </select>
  //           {formErrors.gender && (
  //             <p className="text-red-500 text-sm mt-1">{formErrors.gender}</p>
  //           )}
  //         </div>

  //         {/* Contact: Email + Phone */}
  //         <div>
  //           <Label htmlFor="email">Email*</Label>
  //           <Input
  //             id="email"
  //             name="email"
  //             type="email"
  //             value={form.email || ""}
  //             onChange={handleChange}
  //             disabled={isSaving}
  //             required
  //             placeholder="Enter email address"
  //           />
  //           {formErrors.email && (
  //             <p className="text-red-500 text-sm mt-1">{formErrors.email}</p>
  //           )}
  //         </div>

  //         <div>
  //           <Label htmlFor="phone">Phone*</Label>
  //           <Input
  //             id="phone"
  //             name="phone"
  //             type="tel"
  //             value={form.phone || ""}
  //             onChange={handleChange}
  //             disabled={isSaving}
  //             required
  //             placeholder="Enter phone number"
  //             pattern="^[0-9+\-() ]{7,}$"
  //           />
  //           {formErrors.phone && (
  //             <p className="text-red-500 text-sm mt-1">{formErrors.phone}</p>
  //           )}
  //         </div>

  //           {/* Location */}
  //       <div>
  //         <Label htmlFor="location">Location*</Label>
  //         <select
  //           id="location"
  //           name="location"
  //           value={form.location || ''}
  //           onChange={handleChange}
  //           disabled={isSaving}
  //           required
  //           className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
  //         >
  //           <option value="">Select a location</option>
  //           <option value="Vesu">Vesu</option>
  //           <option value="Varachha">Varachha</option>
  //           <option value="Other">Other</option>
  //         </select>
  //         {formErrors.location && <p className="text-red-500 text-sm mt-2">{formErrors.location}</p>}
  //       </div>

  //         {/* Address */}
  //         <div>
  //           <Label htmlFor="address">Address</Label>
  //           <textarea
  //             id="address"
  //             name="address"
  //             value={form.address || ""}
  //             onChange={handleChange}
  //             disabled={isSaving}
  //             required
  //             rows={3}
  //             placeholder="Street, City, State/Province, ZIP/Postal Code, Country"
  //             className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-blue-500"
  //           />
  //           {formErrors.address && (
  //             <p className="text-red-500 text-sm mt-1">{formErrors.address}</p>
  //           )}
  //         </div>

  //         {/* Emergency Contact */}
  //         <div className="pt-2">
  //           <p className="font-medium mb-2">Emergency Contact</p>
  //           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
  //             <div>
  //               <Label htmlFor="emergencyContactName">Name</Label>
  //               <Input
  //                 id="emergencyContactName"
  //                 name="emergencyContactName"
  //                 value={form.emergencyContactName || ""}
  //                 onChange={handleChange}
  //                 disabled={isSaving}
  //                 required
  //                 placeholder="Full name"
  //               />
  //               {formErrors.emergencyContactName && (
  //                 <p className="text-red-500 text-sm mt-1">{formErrors.emergencyContactName}</p>
  //               )}
  //             </div>

  //             <div>
  //               <Label htmlFor="emergencyContactRelation">Relation</Label>
  //               <Input
  //                 id="emergencyContactRelation"
  //                 name="emergencyContactRelation"
  //                 value={form.emergencyContactRelation || ""}
  //                 onChange={handleChange}
  //                 disabled={isSaving}
  //                 required
  //                 placeholder="e.g., Parent, Spouse, Friend"
  //               />
  //               {formErrors.emergencyContactRelation && (
  //                 <p className="text-red-500 text-sm mt-1">{formErrors.emergencyContactRelation}</p>
  //               )}
  //             </div>

  //             <div>
  //               <Label htmlFor="emergencyContactPhone">Phone</Label>
  //               <Input
  //                 id="emergencyContactPhone"
  //                 name="emergencyContactPhone"
  //                 type="tel"
  //                 value={form.emergencyContactPhone || ""}
  //                 onChange={handleChange}
  //                 disabled={isSaving}
  //                 required
  //                 placeholder="Emergency contact phone number"
  //                 pattern="^[0-9+\-() ]{7,}$"
  //               />
  //               {formErrors.emergencyContactPhone && (
  //                 <p className="text-red-500 text-sm mt-1">{formErrors.emergencyContactPhone}</p>
  //               )}
  //             </div>

            
  //           </div>
  //         </div>
  //       </form>
  //     </CardContent>
  //   </Card>
  // );

  // LeadGenerationForm.propTypes = {
  //   form: PropTypes.shape({
  //     firstName: PropTypes.string,
  //     middleName: PropTypes.string,
  //     lastName: PropTypes.string,
  //     dob: PropTypes.string,
  //     gender: PropTypes.string,
  //     email: PropTypes.string,
  //     phone: PropTypes.string,
  //     location: PropTypes.string,
  //     address: PropTypes.string,
  //     emergencyContactName: PropTypes.string,
  //     emergencyContactRelation: PropTypes.string,
  //     emergencyContactPhone: PropTypes.string,
  //     emergencyContactEmail: PropTypes.string,
  //   }).isRequired,
  //   handleChange: PropTypes.func.isRequired,
  //   formErrors: PropTypes.object.isRequired,
  //   isSaving: PropTypes.bool.isRequired,
  // };

  // export default LeadGenerationForm;





  import PropTypes from "prop-types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { useMemo } from "react";

// Constants for reusable options
const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

const LOCATION_OPTIONS = [
  { value: "Vesu", label: "Vesu" },
  { value: "Varachha", label: "Varachha" },
  { value: "Other", label: "Other" },
];

const LeadGenerationForm = ({ form, handleChange, formErrors, isSaving, onSubmit }) => {
  // Memoize options to prevent unnecessary re-renders
  const genderOptions = useMemo(() => GENDER_OPTIONS, []);
  const locationOptions = useMemo(() => LOCATION_OPTIONS, []);

  // Handle form submission with basic validation
  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    if (!form.firstName) errors.firstName = "First Name is required";
    if (!form.lastName) errors.lastName = "Last Name is required";
    if (!form.gender) errors.gender = "Gender is required";
    if (!form.email) errors.email = "Email is required";
    if (!form.phone) errors.phone = "Phone is required";
    if (!form.location) errors.location = "Location is required";
    if (!form.emergencyContactName) errors.emergencyContactName = "Emergency Contact Name is required";
    if (!form.emergencyContactRelation) errors.emergencyContactRelation = "Emergency Contact Relation is required";
    if (!form.emergencyContactPhone) errors.emergencyContactPhone = "Emergency Contact Phone is required";

    // Optional fields: dob, address (made non-required for flexibility)
    if (form.dob && !/^\d{4}-\d{2}-\d{2}$/.test(form.dob)) {
      errors.dob = "Invalid date format";
    }
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      errors.email = "Invalid email format";
    }
    if (form.phone && !/^[0-9+\-() ]{7,}$/.test(form.phone)) {
      errors.phone = "Invalid phone number";
    }
    if (form.emergencyContactPhone && !/^[0-9+\-() ]{7,}$/.test(form.emergencyContactPhone)) {
      errors.emergencyContactPhone = "Invalid emergency contact phone number";
    }

    if (Object.keys(errors).length > 0) {
      // Pass errors to parent or handle locally
      return;
    }
    onSubmit?.(form);
  };

  return (
    <Card className="p-4 max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle>Lead Generation</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Names */}
          <div>
            <Label htmlFor="firstName">First Name*</Label>
            <Input
              id="firstName"
              name="firstName"
              value={form.firstName || ""}
              onChange={handleChange}
              disabled={isSaving}
              required
              placeholder="Enter first name"
              aria-required="true"
              aria-invalid={!!formErrors.firstName}
            />
            {formErrors.firstName && (
              <p className="text-red-500 text-sm mt-1">{formErrors.firstName}</p>
            )}
          </div>

          <div>
            <Label htmlFor="middleName">Middle Name</Label>
            <Input
              id="middleName"
              name="middleName"
              value={form.middleName || ""}
              onChange={handleChange}
              disabled={isSaving}
              placeholder="Enter middle name"
            />
          </div>

          <div>
            <Label htmlFor="lastName">Last Name*</Label>
            <Input
              id="lastName"
              name="lastName"
              value={form.lastName || ""}
              onChange={handleChange}
              disabled={isSaving}
              required
              placeholder="Enter last name"
              aria-required="true"
              aria-invalid={!!formErrors.lastName}
            />
            {formErrors.lastName && (
              <p className="text-red-500 text-sm mt-1">{formErrors.lastName}</p>
            )}
          </div>

          {/* DOB */}
          <div>
            <Label htmlFor="dob">Date of Birth</Label>
            <Input
              id="dob"
              name="dob"
              type="date"
              value={form.dob || ""}
              onChange={handleChange}
              disabled={isSaving}
              aria-invalid={!!formErrors.dob}
            />
            {formErrors.dob && (
              <p className="text-red-500 text-sm mt-1">{formErrors.dob}</p>
            )}
          </div>

          {/* Gender */}
          <div>
            <Label htmlFor="gender">Gender*</Label>
            <Select
              id="gender"
              name="gender"
              value={form.gender || ""}
              onValueChange={(value) => handleChange({ target: { name: "gender", value } })}
              disabled={isSaving}
              required
              aria-required="true"
              aria-invalid={!!formErrors.gender}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select Gender" />
              </SelectTrigger>
              <SelectContent>
                {genderOptions.map(({ value, label }) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {formErrors.gender && (
              <p className="text-red-500 text-sm mt-1">{formErrors.gender}</p>
            )}
          </div>

          {/* Contact: Email + Phone */}
          <div>
            <Label htmlFor="email">Email*</Label>
            <Input
              id="email"
              name="email"
              type="email"
              value={form.email || ""}
              onChange={handleChange}
              disabled={isSaving}
              required
              placeholder="Enter email address"
              aria-required="true"
              aria-invalid={!!formErrors.email}
            />
            {formErrors.email && (
              <p className="text-red-500 text-sm mt-1">{formErrors.email}</p>
            )}
          </div>

          <div>
            <Label htmlFor="phone">Phone*</Label>
            <Input
              id="phone"
              name="phone"
              type="tel"
              value={form.phone || ""}
              onChange={handleChange}
              disabled={isSaving}
              required
              placeholder="Enter phone number"
              pattern="[0-9+\-() ]{7,}"
              aria-required="true"
              aria-invalid={!!formErrors.phone}
            />
            {formErrors.phone && (
              <p className="text-red-500 text-sm mt-1">{formErrors.phone}</p>
            )}
          </div>

          {/* Location */}
          <div>
            <Label htmlFor="location">Location*</Label>
            <Select
              id="location"
              name="location"
              value={form.location || ""}
              onValueChange={(value) => handleChange({ target: { name: "location", value } })}
              disabled={isSaving}
              required
              aria-required="true"
              aria-invalid={!!formErrors.location}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select a location" />
              </SelectTrigger>
              <SelectContent>
                {locationOptions.map(({ value, label }) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {formErrors.location && (
              <p className="text-red-500 text-sm mt-1">{formErrors.location}</p>
            )}
          </div>

          {/* Address */}
          <div>
            <Label htmlFor="address">Address</Label>
            <Textarea
              id="address"
              name="address"
              value={form.address || ""}
              onChange={handleChange}
              disabled={isSaving}
              rows={3}
              placeholder="Street, City, State/Province, ZIP/Postal Code, Country"
              aria-label="Address"
              aria-invalid={!!formErrors.address}
            />
            {formErrors.address && (
              <p className="text-red-500 text-sm mt-1">{formErrors.address}</p>
            )}
          </div>

          {/* Emergency Contact */}
          <div className="pt-2">
            <h3 className="font-medium mb-2">Emergency Contact</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label htmlFor="emergencyContactName">Name</Label>
                <Input
                  id="emergencyContactName"
                  name="emergencyContactName"
                  value={form.emergencyContactName || ""}
                  onChange={handleChange}
                  disabled={isSaving}
                  required
                  placeholder="Full name"
                  aria-required="true"
                  aria-invalid={!!formErrors.emergencyContactName}
                />
                {formErrors.emergencyContactName && (
                  <p className="text-red-500 text-sm mt-1">{formErrors.emergencyContactName}</p>
                )}
              </div>

              <div>
                <Label htmlFor="emergencyContactRelation">Relation</Label>
                <Input
                  id="emergencyContactRelation"
                  name="emergencyContactRelation"
                  value={form.emergencyContactRelation || ""}
                  onChange={handleChange}
                  disabled={isSaving}
                  required
                  placeholder="e.g., Parent, Spouse, Friend"
                  aria-required="true"
                  aria-invalid={!!formErrors.emergencyContactRelation}
                />
                {formErrors.emergencyContactRelation && (
                  <p className="text-red-500 text-sm mt-1">{formErrors.emergencyContactRelation}</p>
                )}
              </div>

              <div>
                <Label htmlFor="emergencyContactPhone">Phone</Label>
                <Input
                  id="emergencyContactPhone"
                  name="emergencyContactPhone"
                  type="tel"
                  value={form.emergencyContactPhone || ""}
                  onChange={handleChange}
                  disabled={isSaving}
                  required
                  placeholder="Emergency contact phone number"
                  pattern="[0-9+\-() ]{7,}"
                  aria-required="true"
                  aria-invalid={!!formErrors.emergencyContactPhone}
                />
                {formErrors.emergencyContactPhone && (
                  <p className="text-red-500 text-sm mt-1">{formErrors.emergencyContactPhone}</p>
                )}
              </div>
            </div>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

LeadGenerationForm.propTypes = {
  form: PropTypes.shape({
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    dob: PropTypes.string,
    gender: PropTypes.oneOf(["male", "female", ""]),
    email: PropTypes.string,
    phone: PropTypes.string,
    location: PropTypes.oneOf(["Vesu", "Varachha", "Other", ""]),
    address: PropTypes.string,
    emergencyContactName: PropTypes.string,
    emergencyContactRelation: PropTypes.string,
    emergencyContactPhone: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    dob: PropTypes.string,
    gender: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    location: PropTypes.string,
    address: PropTypes.string,
    emergencyContactName: PropTypes.string,
    emergencyContactRelation: PropTypes.string,
    emergencyContactPhone: PropTypes.string,
  }).isRequired,
  isSaving: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func,
};

export default LeadGenerationForm;